import React from "react";
import {connect} from "react-redux";
import MybooksPage from "./MyBooksPage";

const BooksPage = (props) => {
    return(
        <div>
        {props.books ?
            <div>
                <h1 className="content_title">Total {props.totalBooks} Books</h1>
            <MybooksPage/> </div>: <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>}

        </div>
    );
};

function mapStateToProps(state){
    return {books: state.AllBooks.books, totalBooks: state.user.totalBooks}
}

export default connect(mapStateToProps, {})(BooksPage);